import React, { useState, useEffect } from "react";
import './barcodeExpandedStacked.css';
import MainWrapper from "../../components/layout/layout";
import { Navigate, useLoaderData, useNavigate } from "react-router-dom";
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import Stack from '@mui/material/Stack';
import MailIcon from '@mui/icons-material/Mail';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import Skeleton from '@mui/material/Skeleton';
import Autocomplete from '@mui/material/Autocomplete';
import { Container } from "@mui/system";
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import bwipjs from "bwip-js";
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import { MyDocument } from "./doc";
import { pdf } from '@react-pdf/renderer';
import { imageUpload } from "../../services/image";
import { getImageDimensions, haveNegativeOrDecimal, numericFilter } from "../../utils/utils";
import Spinner from 'react-bootstrap/Spinner';
import AddIcon from '@mui/icons-material/Add';
import InfoIcon from '@mui/icons-material/Info';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Tooltip from '@mui/material/Tooltip';
import { getCompanyPrefix } from "../../services/companyPrefix";
import { getProductCategory } from "../../services/productCategory";
import { createCoupon } from "../../services/coupon";
import { isSubscriptionRequiredError } from "../../services/subscription";
import axiosInstance from "../../services/axiosConfig";
import { SubscriptionModal } from "../../components/modal/SubscriptionModal";
import AddCardIcon from '@mui/icons-material/AddCard';
import Paper from '@mui/material/Paper';
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import DownloadIcon from '@mui/icons-material/Download';
import SendIcon from '@mui/icons-material/Send';
import DeleteIcon from '@mui/icons-material/Delete';
import ConfirmationNumberIcon from "@mui/icons-material/ConfirmationNumber";
import Link from '@mui/material/Link';
import html2canvas from 'html2canvas';

const steps = ['Enter Coupon Details', 'Add Usage Rules', 'Generate Barcode', 'Design Coupon'];

function BarcodeWizard() {
  const navigate = useNavigate();
  const loader = useLoaderData();

  const [activeStep, setActiveStep] = useState(0);
  const [data, setData] = useState({});
  const [companyPrefixes, setCompanyPrefixes] = useState([]);
  const [email, setEmail] = useState("");
  const [open, setOpen] = useState(false);
  const [alertType, setAlertType] = useState("success");
  const [alertText, setAlertText] = useState("");
  const [src, setImageSrc] = useState(false);
  const [fieldType, setFieldType] = useState("");
  const [fileType, setFileType] = useState("png");
  const [imageDimension, setImageDimension] = useState({});
  const [dataString, setDataString] = useState("");
  const [reportDownloaded, setReportDownloaded] = useState(false);
  const [inpFieldError, setInpFieldError] = useState(false);
  const [companyPrefixReq, setCompanyPrefixReq] = useState(false);
  const [offerCodeReq, setOfferCodeReq] = useState(false);
  const [saveValueReq, setSaveValueReq] = useState(false);
  const [primaryPurchaseRequirementReq, setPrimaryPurchaseRequirementReq] = useState(false);
  const [primaryPurchaseRequirementCodeReq, setPrimaryPurchaseRequirementCodeReq] = useState(false);
  const [primaryPurchaseFamilyCodeReq, setPrimaryPurchaseFamilyCodeReq] = useState(false);
  const [imageUploaded, setImageUploaded] = useState(false);
  const [showSecondPurchase, setShowSecondPurchase] = useState(false);
  const [showSerialNumber, setShowSerialNumber] = useState(false);
  const [showRetailer, setShowRetailer] = useState(false);
  const [freeCoupon, setFreeCoupon] = useState(false);
  const [limitedPerOne, setLimitedPerOne] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [expiryDate, setExpiryDate] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [secondPurchaseCompany, setSecondPurchaseCompany] = useState(null);
  const [additionalFieldRequired, setAdditionalFieldRequired] = useState(false);
  const [valueCodeFlagAppliesRequired, setValueCodeFlagAppliesRequired] = useState(false);
  const [productImage, setProductImage] = useState([]);
  const [productData, setProductData] = useState({});
  const [productCategories, setProductCategories] = useState([]);
  const [couponEmail, setCouponEmail] = useState("");
  const [downloadQuality, setDownloadQuality] = useState("high"); // standard, high, print
  const [showSubscriptionModal, setShowSubscriptionModal] = useState(false);

  // Check if user is admin
  useEffect(() => {
    document.title = "Create Your Barcode - Wizard";
    const userData = JSON.parse(loader);
    if (userData?.email === process.env.REACT_APP_ADMIN_EMAIL) {
      setIsAdmin(true);
    }
  }, []);

  // Cleanup body class on unmount
  useEffect(() => {
    return () => {
      document.body.classList.remove("subscription-modal-open");
    };
  }, []);

  const handleShowSubscriptionModal = () => {
    document.body.classList.add("subscription-modal-open");
    setShowSubscriptionModal(true);
  };

  const handleHideSubscriptionModal = () => {
    document.body.classList.remove("subscription-modal-open");
    setShowSubscriptionModal(false);
  };

  // Get GS1 company prefix
  const getPrefix = async () => {
    setCompanyPrefixes([]);
    const res = await getCompanyPrefix();
    if (res === null) return;
    res.map((d) => [
      setCompanyPrefixes(data => [...data, { "label": d.company_name, "value": d.gs1_company_prefix }])
    ]);
  };

  useEffect(() => {
    getPrefix();
  }, []);

  // Get product categories
  const getCategories = async () => {
    setProductCategories([]);
    const res = await getProductCategory();
    if (res === null) return;
    res.map((d) => [
      setProductCategories(data => [...data, { label: d.product_category_name, value: d.product_category_name }])
    ]);
  };

  useEffect(() => {
    getCategories();
  }, []);

  // Free coupon and limited per one functionality
  useEffect(() => {
    if (freeCoupon && !limitedPerOne) {
      setData({ ...data, "saveValueCode": 1, "multiplyFlag": "", "saveValueAppliesItem": "", "storeCoupon": "" });
    } else if (limitedPerOne && !freeCoupon) {
      setData({ ...data, "multiplyFlag": 1, "saveValueCode": "", "saveValueAppliesItem": "", "storeCoupon": "" });
    } else if (freeCoupon === true && limitedPerOne === true) {
      setData({ ...data, "saveValueAppliesItem": "0", "storeCoupon": "0", "saveValueCode": 1, "multiplyFlag": 1 });
    } else {
      setData({ ...data, "saveValueAppliesItem": "", "storeCoupon": "", "saveValueCode": "", "multiplyFlag": "" });
    }
  }, [freeCoupon, limitedPerOne]);

  // Additional fields required check
  useEffect(() => {
    if (data.additionalPurchaseRuleCode && data.additionalPurchaseRuleCode.length !== 0) {
      setAdditionalFieldRequired(true);
    } else {
      setAdditionalFieldRequired(false);
    }
  }, [data.additionalPurchaseRuleCode]);

  // Value code flag applies fields required check
  useEffect(() => {
    if (data.saveValueCode || data.saveValueAppliesItem || data.multiplyFlag || data.storeCoupon) {
      setValueCodeFlagAppliesRequired(true);
    } else {
      setValueCodeFlagAppliesRequired(false);
    }
  }, [data.saveValueCode, data.saveValueAppliesItem, data.multiplyFlag, data.storeCoupon]);

  const generateBarcode = async (scale = 1) => {
    try {
      const string = `(8110)${data.companyPrefix.length - 6}${data.companyPrefix}${data.offerCode}${data.saveValue.length}${data.saveValue}${data.primaryPurchaseRequirement.length}${data.primaryPurchaseRequirement}${data.primaryPurchaseRequirementCode}${data.primaryPurchaseFamilyCode}${data.additionalPurchaseRuleCode ? `1${data.additionalPurchaseRuleCode}${data.secondPurchaseRequirement.length}${data.secondPurchaseRequirement}${data.secondPurchaseRequirementCode}${data.secondPurchaseFamilyCode}${data.secondCompanyPrefix.length - 6}${data.secondCompanyPrefix}` : ''}${data.expiryDate ? `3${data.expiryDate}` : ''}${data.startDate ? `4${data.startDate}` : ''}${data.serialNumber ? `5${data.serialNumber.length - 6}${data.serialNumber}` : ''}${data.retailerCompanyPrefix ? `6${data.retailerCompanyPrefix.length - 6}${data.retailerCompanyPrefix}` : ''}${data.saveValueCode ? `9${data.saveValueCode}${data.saveValueAppliesItem}${data.storeCoupon}${data.multiplyFlag}` : ''}`;

      let segment = 4;
      if (string.length < 35) {
        segment = 6;
      } else if (string.length >= 35 && string.length < 50) {
        segment = 8;
      } else {
        segment = 12;
      }

      let canvas = document.createElement("canvas");
      await bwipjs.toCanvas(canvas, {
        bcid: "databarexpandedstacked",
        text: string,
        alttext: `${data.companyPrefix}-${data.offerCode}`,
        segments: segment,
        scale: scale,
        textsize: 16,
        includetext: true,
        padding: 0,
        textyalign: "above",
        backgroundcolor: "#FFFFFF",
        textxalign: 'left',
      });

      const base64 = canvas.toDataURL("image/png");
      const finalString = string.split("(").join("").split(")").join("");

      // Only update state when generating preview (scale = 1)
      if (scale === 1) {
        setDataString(finalString);
        setReportDownloaded(false);
        setImageUploaded(false);
        setOpen(false);
        setImageSrc(base64);
        const dimension = await getImageDimensions(base64);
        setImageDimension(dimension);
      }

      return base64;
    } catch (error) {
      if (scale === 1) {
        setImageSrc(false);
      }
      alert(error.message.split(":").pop());
      console.log("barcode error: ", error);
      return null;
    }
  };

  // Generate high-resolution barcode for downloads
  const generateHighResBarcode = async () => {
    let scale = 1;
    switch (downloadQuality) {
      case "standard":
        scale = 3;
        break;
      case "high":
        scale = 6;
        break;
      case "print":
        scale = 10;
        break;
      default:
        scale = 6;
    }
    return await generateBarcode(scale);
  };

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });

    if (e.target.name === "offerCode" && (e.target.value.length !== 6 || haveNegativeOrDecimal(e.target.value))) {
      setFieldType("offerCode");
      setInpFieldError(true);
      return;
    }
    setFieldType("");

    if (e.target.name === "saveValue" && (e.target.value.length > 5 || haveNegativeOrDecimal(e.target.value))) {
      setFieldType("saveValue");
      setInpFieldError(true);
      return;
    }
    setFieldType("");

    if (e.target.name === "primaryPurchaseRequirement" && (e.target.value.length > 5 || haveNegativeOrDecimal(e.target.value))) {
      setFieldType("primaryPurchaseRequirement");
      setInpFieldError(true);
      return;
    }
    setFieldType("");

    if (e.target.name === "primaryPurchaseRequirementCode") {
      const value = e.target.value;
      const validValues = ['0', '1', '2', '3', '4', '9'];
      if (value.length > 1 || (value.length === 1 && !validValues.includes(value))) {
        setFieldType("primaryPurchaseRequirementCode");
        setInpFieldError(true);
        return;
      }
      if (value.length === 1 && validValues.includes(value)) {
        setFieldType("");
        setInpFieldError(false);
      }
    }

    if (e.target.name === "primaryPurchaseFamilyCode" && (e.target.value.length !== 3 || haveNegativeOrDecimal(e.target.value))) {
      setFieldType("primaryPurchaseFamilyCode");
      setInpFieldError(true);
      return;
    }
    setFieldType("");

    if (e.target.name === "additionalPurchaseRuleCode" && e.target.value.length !== 0) {
      const value = e.target.value;
      const validValues = ['0', '1', '2', '3'];
      if (value.length > 1 || (value.length === 1 && !validValues.includes(value))) {
        setFieldType("additionalPurchaseRuleCode");
        setInpFieldError(true);
        return;
      }
      if (value.length === 1 && validValues.includes(value)) {
        setFieldType("");
        setInpFieldError(false);
      }
    }

    if (e.target.name === "secondPurchaseRequirement" && (e.target.value.length > 5 || haveNegativeOrDecimal(e.target.value))) {
      setFieldType("secondPurchaseRequirement");
      setInpFieldError(true);
      return;
    }
    setFieldType("");

    if (e.target.name === "secondPurchaseRequirementCode" && e.target.value.length !== 0) {
      const value = e.target.value;
      const validValues = ['0', '1', '2', '3', '4', '9'];
      if (value.length > 1 || (value.length === 1 && !validValues.includes(value))) {
        setFieldType("secondPurchaseRequirementCode");
        setInpFieldError(true);
        return;
      }
      if (value.length === 1 && validValues.includes(value)) {
        setFieldType("");
        setInpFieldError(false);
      }
    }

    if (e.target.name === "secondPurchaseFamilyCode" && (e.target.value.length !== 3 || haveNegativeOrDecimal(e.target.value))) {
      setFieldType("secondPurchaseFamilyCode");
      setInpFieldError(true);
      return;
    }
    setFieldType("");

    if (e.target.name === "serialNumber" && (e.target.value.length < 6 || e.target.value.length > 15 || haveNegativeOrDecimal(e.target.value))) {
      setFieldType("serialNumber");
      setInpFieldError(true);
      return;
    }
    setFieldType("");

    if (e.target.name === "saveValueCode" && e.target.value.length !== 0 && e.target.value !== "0" && e.target.value !== "1" && e.target.value !== "2") {
      setFieldType("saveValueCode");
      setInpFieldError(true);
      return;
    }
    setFieldType("");

    if (e.target.name === "saveValueAppliesItem" && e.target.value.length !== 0 && e.target.value !== "0" && e.target.value !== "1" && e.target.value !== "2") {
      setFieldType("saveValueAppliesItem");
      setInpFieldError(true);
      return;
    }
    setFieldType("");

    if (e.target.name === "storeCoupon" && e.target.value.length !== 0 && e.target.value !== "0" && e.target.value !== "1" && e.target.value !== "2") {
      setFieldType("storeCoupon");
      setInpFieldError(true);
      return;
    }
    setFieldType("");

    if (e.target.name === "multiplyFlag" && e.target.value.length !== 0 && e.target.value !== "0" && e.target.value !== "1") {
      setFieldType("multiplyFlag");
      setInpFieldError(true);
      return;
    }
    setFieldType("");

    setInpFieldError(false);
  };

  const handleDropdownChange = (e, rowValue, reason) => {
    if (reason === "selectOption" && rowValue) {
      setData({ ...data, "companyPrefix": rowValue.value });
    } else if (reason === "clear") {
      setData({ ...data, "companyPrefix": "" });
    }
  };

  const handleSecondDropdownChange = (e, rowValue, reason) => {
    if (reason === "selectOption" && rowValue) {
      setData({ ...data, "secondCompanyPrefix": rowValue.value });
      setSecondPurchaseCompany(rowValue);
    } else if (reason === "clear") {
      delete data.secondCompanyPrefix;
      setSecondPurchaseCompany(null);
    }
  };

  const handleRetailerDropdownChange = (e, rowValue, reason) => {
    if (reason === "selectOption" && rowValue) {
      setData({ ...data, "retailerCompanyPrefix": rowValue.value });
    } else if (reason === "clear") {
      delete data.retailerCompanyPrefix;
    }
  };

  const handleDateChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value.split("-").join("").slice(2) });
    if (e.target.name === "expiryDate") {
      setExpiryDate(e.target.value);
    }
    if (e.target.name === "startDate") {
      setStartDate(e.target.value);
    }
  };

  const handleFileTypeChange = (e) => {
    setFileType(e.target.value);
  };

  const handleQualityChange = (e) => {
    setDownloadQuality(e.target.value);
  };

  const handleSecondPurchaseAppearance = () => {
    setShowSecondPurchase(!showSecondPurchase);
    setData({ ...data, "additionalPurchaseRuleCode": "", "secondPurchaseRequirement": "", "secondPurchaseRequirementCode": "", "secondPurchaseFamilyCode": "", "secondCompanyPrefix": "" });
    setSecondPurchaseCompany(null);
  };

  const validateStep = (step) => {
    if (step === 0) {
      let isValid = true;
      if (!data.companyPrefix) {
        setCompanyPrefixReq(true);
        isValid = false;
      } else {
        setCompanyPrefixReq(false);
      }
      if (!data.offerCode) {
        setOfferCodeReq(true);
        isValid = false;
      } else {
        setOfferCodeReq(false);
      }
      if (!data.saveValue) {
        setSaveValueReq(true);
        isValid = false;
      } else {
        setSaveValueReq(false);
      }
      if (!data.primaryPurchaseRequirement) {
        setPrimaryPurchaseRequirementReq(true);
        isValid = false;
      } else {
        setPrimaryPurchaseRequirementReq(false);
      }
      if (!data.primaryPurchaseRequirementCode) {
        setPrimaryPurchaseRequirementCodeReq(true);
        isValid = false;
      } else {
        setPrimaryPurchaseRequirementCodeReq(false);
      }
      if (!data.primaryPurchaseFamilyCode) {
        setPrimaryPurchaseFamilyCodeReq(true);
        isValid = false;
      } else {
        setPrimaryPurchaseFamilyCodeReq(false);
      }
      // Check if there are any field-specific errors or general input errors
      if (inpFieldError || fieldType !== "") {
        isValid = false;
      }
      return isValid;
    }

    if (step === 1) {
      let isValid = true;
      // If any of the 4 value code fields are filled, all 4 must be filled
      if (valueCodeFlagAppliesRequired) {
        if (!data.saveValueCode || data.saveValueCode === "") {
          isValid = false;
        }
        if (!data.saveValueAppliesItem || data.saveValueAppliesItem === "") {
          isValid = false;
        }
        if (!data.storeCoupon || data.storeCoupon === "") {
          isValid = false;
        }
        if (!data.multiplyFlag || data.multiplyFlag === "") {
          isValid = false;
        }
      }
      // Check if there are any field-specific errors
      if (inpFieldError || fieldType !== "") {
        isValid = false;
      }
      return isValid;
    }

    return true;
  };

  const handleNext = async () => {
    if (validateStep(activeStep)) {
      if (activeStep === 1) {
        // Generate barcode when moving from step 1 to step 2
        await generateBarcode();
      }
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const downloadPDF = async () => {
    const blob = await pdf(<MyDocument data={data} string={dataString} />).toBlob();
    let a = document.createElement("a");
    document.body.appendChild(a);
    let url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = "coupon_report.pdf";
    a.click();
    window.URL.revokeObjectURL(url);
    setReportDownloaded(true);
  };

  const uploadBarcode = async () => {
    if (imageUploaded) return;
    const result = await imageUpload(src, dataString, "Barcode");
    if (result === "File saved successfully") {
      setImageUploaded(true);
      setTimeout(() => setOpen(false), 1500);
      setTimeout(() => {
        setAlertType("success");
        setAlertText("Barcode successfully Uploaded");
        setOpen(true);
      }, 3000);
    } else {
      setImageUploaded(false);
      setAlertType("error");
      setAlertText("Some error occurred while uploading Image");
      setOpen(true);
    }
  };

  const handleDownload = async () => {
    try {
      const downloadLink = document.createElement("a");
      uploadBarcode();

      // Generate high-resolution barcode for download
      const highResSrc = await generateHighResBarcode();
      if (!highResSrc) {
        setAlertType("error");
        setAlertText("Error generating high-resolution barcode");
        setOpen(true);
        return;
      }

      let res;
      if (fileType === "png") {
        res = await axiosInstance.post('/manufacturer/base-to-png/', { data_string: highResSrc, name_string: dataString });
      } else if (fileType === "pdf") {
        res = await axiosInstance.post('/manufacturer/base-to-pdf/', { data_string: highResSrc, name_string: dataString });
      } else if (fileType === "eps") {
        res = await axiosInstance.post('/manufacturer/base-to-eps/', { data_string: highResSrc, name_string: dataString });
      }

      if (res?.data?.download_link) {
        downloadLink.href = res.data.download_link;
        downloadLink.click();
      }
    } catch (error) {
      console.error('Error downloading barcode:', error);
      if (isSubscriptionRequiredError(error)) {
        handleShowSubscriptionModal();
        return;
      }
      setAlertType("error");
      setAlertText("Error downloading barcode");
      setOpen(true);
    }
  };

  const handleSendMail = async (e) => {
    e.preventDefault();

    try {
      // Generate high-resolution barcode for email
      const highResSrc = await generateHighResBarcode();
      if (!highResSrc) {
        setAlertType("error");
        setAlertText("Error generating high-resolution barcode");
        setOpen(true);
        return;
      }

      const mailData = {
        email_add: email,
        img_url: highResSrc.split(",")[1],
        file_type: fileType,
        name_string: dataString,
        code_type: "Barcode"
      };

      await axiosInstance.post('/manufacturer/send/', mailData);
      setAlertType("success");
      setAlertText("Barcode successfully sent.");
      setOpen(true);
      uploadBarcode();
    } catch (error) {
      console.error('Error sending barcode email:', error);
      if (isSubscriptionRequiredError(error)) {
        handleShowSubscriptionModal();
        return;
      }
      setAlertType("error");
      setAlertText("Some error occurred while sending mail");
      setOpen(true);
    }
  };

  const onEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const navigateCreateCoupon = () => {
    navigate("/create-coupon", {
      state: {
        type: "Barcode",
        src: src,
        dataString: dataString,
        codeData: data,
        expiryDate: expiryDate,
        startDate: startDate,
        OfferDetails: false
      }
    });
  };

  // Product form handlers
  const convertToBase64 = (file) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      setProductImage((items) => [...items, reader.result]);
    };
  };

  const handleProductChange = (e) => {
    setProductData({ ...productData, [e.target.name]: e.target.value });
  };

  const handleCategoryChange = (e, rowValue, reason) => {
    if (reason === "selectOption") {
      setProductData({ ...productData, category: rowValue.value });
    }
  };

  // Download whole coupon as image
  const handleDownloadCoupon = async () => {
    const couponElement = document.getElementById('coupon-preview');
    if (!couponElement) return;

    try {
      // Check subscription status before download
      const statusRes = await axiosInstance.get('/payments/status/');
      if (!statusRes.data?.is_subscribed) {
        handleShowSubscriptionModal();
        return;
      }

      const canvas = await html2canvas(couponElement, {
        backgroundColor: '#ffffff',
        scale: 2,
        logging: false,
        useCORS: true
      });

      const link = document.createElement('a');
      link.download = `coupon-${dataString || 'preview'}.png`;
      link.href = canvas.toDataURL('image/png');
      link.click();
    } catch (error) {
      console.error('Error downloading coupon:', error);
      if (isSubscriptionRequiredError(error)) {
        handleShowSubscriptionModal();
        return;
      }
      setAlertType("error");
      setAlertText("Error downloading coupon");
      setOpen(true);
    }
  };

  // Send coupon via email
  const handleSendCouponEmail = async (e) => {
    e.preventDefault();
    const couponElement = document.getElementById('coupon-preview');
    if (!couponElement || !couponEmail) return;

    try {
      const canvas = await html2canvas(couponElement, {
        backgroundColor: '#ffffff',
        scale: 2,
        logging: false,
        useCORS: true
      });

      const base64Image = canvas.toDataURL('image/png').split(',')[1];

      const mailData = {
        email_add: couponEmail,
        img_url: base64Image,
        file_type: "png",
        name_string: `coupon_${dataString || Date.now()}`,
        code_type: "Coupon Image"
      };

      await axiosInstance.post('/manufacturer/send/', mailData);
      setAlertType("success");
      setAlertText("Coupon successfully sent to email");
      setOpen(true);
      setCouponEmail(""); // Clear email field after sending
    } catch (error) {
      console.error('Error sending coupon email:', error);
      if (isSubscriptionRequiredError(error)) {
        handleShowSubscriptionModal();
        return;
      }
      setAlertType("error");
      setAlertText("Error sending coupon via email");
      setOpen(true);
    }
  };

  // Save coupon to database
  const handleSaveCoupon = async () => {
    try {
      const userData = JSON.parse(loader);
      const email = userData?.email;

      if (!email) {
        setAlertType("error");
        setAlertText("User email not found");
        setOpen(true);
        return;
      }

      // Generate high-resolution barcode for storage (print quality - scale 10)
      setAlertType("info");
      setAlertText("Generating high-resolution barcode...");
      setOpen(true);

      const highResBarcode = await generateBarcode(10); // Scale 10 for print quality
      if (!highResBarcode) {
        setAlertType("error");
        setAlertText("Error generating high-resolution barcode");
        setOpen(true);
        return;
      }

      // Validate product images - backend requires at least one image
      if (!productImage || productImage.length === 0) {
        setAlertType("error");
        setAlertText("Please add at least one product image before saving");
        setOpen(true);
        return;
      }

      // Provide default values if fields are empty
      const consumerText = productData.consumer || "Do not double. Valid one per household. Consumer pays sales tax.";
      const retailerText = productData.retailer || "Do not double. Void when reproduced, copied, transferred, or purchased. Retailer: Send to manufacturer for reimbursement.";
      const footerText = "Terms and conditions apply.";

      // Format date properly or send empty string (API will handle validation)
      const formattedExpiryDate = expiryDate || null;

      const result = await createCoupon(
        email,
        dataString,
        "Barcode",
        highResBarcode, // Use high-resolution barcode instead of preview
        productData.name || "Product",
        productData.category || "General",
        productData.shortDesc || "Product description",
        "Limit one Coupon per visit | Manufacturer's Coupon", // header
        consumerText,
        retailerText,
        footerText,
        formattedExpiryDate,
        productData.offerDesc || "Special Offer",
        productImage
      );

      if (result) {
        setAlertType("success");
        setAlertText("Coupon saved successfully with high-resolution barcode!");
        setOpen(true);

        // Reset form after 2 seconds
        setTimeout(() => {
          setActiveStep(0);
          setData({});
          setProductData({});
          setProductImage([]);
          setImageSrc(false);
          setExpiryDate(null);
          setStartDate(null);
        }, 2000);
      } else {
        setAlertType("error");
        setAlertText("Failed to save coupon");
        setOpen(true);
      }
    } catch (error) {
      console.error('Error saving coupon:', error);
      if (isSubscriptionRequiredError(error)) {
        setOpen(false); // Close the "Generating..." alert
        handleShowSubscriptionModal();
        return;
      }
      setAlertType("error");
      setAlertText("Error saving coupon");
      setOpen(true);
    }
  };

  if (loader === null) {
    return (
      <div className="loaderParent">
        <Spinner animation="border" variant="primary" />
        <Navigate to="/login/barcode" replace={true} />
      </div>
    );
  }

  return (
    <MainWrapper>
      <div id="dpi"></div>
      <Box sx={{ width: '100%', height: 'calc(100vh - 145px)', display: 'flex', flexDirection: 'column', overflow: 'hidden', mt: '65px' }}>
        {/* Step Title and Progress Bar */}
        <Box sx={{ px: 3, pt: 1.5, pb: 1.5, bgcolor: 'white', zIndex: 10, position: 'sticky', top: 0 }}>
          <Box>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', mb: 0.5, minHeight: '32px' }}>
              {activeStep > 0 && (
                <IconButton
                  onClick={handleBack}
                  size="small"
                  sx={{
                    mr: 1,
                    p: 0.5,
                    border: '1px solid #e0e0e0',
                    borderRadius: '8px',
                    alignSelf: 'center'
                  }}
                >
                  <ChevronLeftIcon />
                </IconButton>
              )}
              <Typography variant="h6" sx={{ fontSize: '1.1rem', color: 'black', lineHeight: 1 }}>
                {activeStep === 0 && 'Enter Coupon Details'}
                {activeStep === 1 && 'Add Usage Rules'}
                {activeStep === 2 && 'Generate Barcode'}
                {activeStep === 3 && 'Design Coupon'}
              </Typography>
            </Box>
            <Typography variant="body2" sx={{ mb: 1.5, fontSize: '0.8rem', color: 'black', ml: activeStep > 0 ? '40px' : '0' }}>
              {activeStep === 0 && 'Required Data Elements'}
              {activeStep === 1 && 'Optional Data Elements'}
              {activeStep === 2 && 'Export Barcode Image'}
              {activeStep === 3 && 'Preview and Finalize Coupon'}
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', gap: 1 }}>
            {steps.map((label, index) => (
              <Box
                key={label}
                sx={{
                  flex: 1,
                  height: 8,
                  bgcolor: index <= activeStep ? '#1976d2' : '#e0e0e0',
                  borderRadius: 2,
                  transition: 'background-color 0.3s ease'
                }}
              />
            ))}
          </Box>
        </Box>

        {/* Alert */}
        <Box sx={{ px: 3 }}>
          <Collapse in={open}>
            <Alert
              severity={alertType}
              action={
                <IconButton
                  aria-label="close"
                  color="inherit"
                    onClick={() => setOpen(false)}
                >
                  <CloseIcon fontSize="inherit" />
                </IconButton>
              }
              sx={{ mb: 1, py: 0.5 }}
            >
              {alertText}
            </Alert>
          </Collapse>
        </Box>

        {/* Step Content */}
        <Box sx={{ flex: 1, overflow: 'auto', px: 3, pb: 3, pt: 3 }}>
          <Paper elevation={0} sx={{ p: 0 }}>
          {activeStep === 0 && (
            <Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1.5 }}>
                <Autocomplete
                  disablePortal
                  id="companyPrefix"
                  options={companyPrefixes}
                  name="companyPrefix"
                  value={companyPrefixes.find(cp => cp.value === data.companyPrefix) || null}
                  onChange={handleDropdownChange}
                  autoSelect={true}
                  loading={companyPrefixes.length === 0}
                  sx={{ flex: 1 }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Primary GS1 Company Prefix"
                      error={companyPrefixReq}
                      helperText={companyPrefixReq && "Please select a GS1 Company Prefix"}
                      autoFocus
                      size="small"
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          borderRadius: '20px',
                        },
                        '& .MuiFormHelperText-root': {
                          fontSize: '0.7rem',
                        }
                      }}
                    />
                  )}
                />
                <Tooltip title="Add company prefix">
                  <IconButton
                    className={isAdmin ? "" : "hide"}
                    onClick={() => navigate("/companyprefixes/login")}
                    color="primary"
                    sx={{
                      border: '1px solid #1976d2',
                      borderRadius: '50%',
                      width: 36,
                      height: 36,
                      flexShrink: 0
                    }}
                  >
                    <AddIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              </Box>

              <FormControlLabel
                control={<Checkbox size="small" />}
                label={<Typography fontSize="0.85rem">Add Company Prefixes</Typography>}
                sx={{ mb: 1.5 }}
              />

              <Grid container spacing={1.5}>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    size="small"
                    id="offerCode"
                    name="offerCode"
                    type="number"
                    label="Offer Code"
                    placeholder="6 digits"
                    variant="outlined"
                    value={data.offerCode || ""}
                    onKeyDown={numericFilter}
                    onChange={handleChange}
                    error={fieldType === "offerCode" || offerCodeReq}
                    helperText={(fieldType === "offerCode" || offerCodeReq) && "Please enter exactly 6 digits (e.g., 123456)"}
                    InputProps={{
                      endAdornment: (
                        <Tooltip title="A 6 digit number used to track your offer. If this is your first coupon, use 000001.">
                          <InfoIcon fontSize="small" color="action" />
                        </Tooltip>
                      ),
                    }}
                    sx={{
                      '& .MuiOutlinedInput-root': { borderRadius: '20px' },
                      '& .MuiFormHelperText-root': { fontSize: '0.7rem' }
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    size="small"
                    id="saveValue"
                    name="saveValue"
                    type="number"
                    label="Save Value"
                    placeholder="1-5 digits"
                    variant="outlined"
                    value={data.saveValue || ""}
                    onKeyDown={numericFilter}
                    onChange={handleChange}
                    error={fieldType === "saveValue" || saveValueReq}
                    helperText={(fieldType === "saveValue" || saveValueReq) && "Please enter 1-5 digits (e.g., 100 for $1.00)"}
                    InputProps={{
                      endAdornment: (
                        <Tooltip title="The value of this coupon ('cents off,' or other value as specified). If Save Value is $0.50, input 50. If Save Value is $1.00, input 100. If your save value is $10.00, input 1000.">
                          <InfoIcon fontSize="small" color="action" />
                        </Tooltip>
                      ),
                    }}
                    sx={{
                      '& .MuiOutlinedInput-root': { borderRadius: '20px' },
                      '& .MuiFormHelperText-root': { fontSize: '0.7rem' }
                    }}
                  />
                </Grid>
              </Grid>

              <TextField
                fullWidth
                size="small"
                id="primaryPurchaseRequirement"
                name="primaryPurchaseRequirement"
                type="number"
                label="Primary Purchase Requirement"
                placeholder="1-5 digits"
                variant="outlined"
                value={data.primaryPurchaseRequirement || ""}
                onKeyDown={numericFilter}
                onChange={handleChange}
                error={fieldType === "primaryPurchaseRequirement" || primaryPurchaseRequirementReq}
                helperText={(fieldType === "primaryPurchaseRequirement" || primaryPurchaseRequirementReq) && "Please enter number of units required (1-5 digits)"}
                InputProps={{
                  endAdornment: (
                    <Tooltip title="The number of units the consumer must bring to the POS to obtain the offer. (Ex: Save $1.00 off one item of x, your Primary Purchase Requirement would be 1.)">
                      <InfoIcon fontSize="small" color="action" />
                    </Tooltip>
                  ),
                }}
                sx={{
                  mt: 1,
                  '& .MuiOutlinedInput-root': { borderRadius: '20px' },
                  '& .MuiFormHelperText-root': { fontSize: '0.7rem' }
                }}
              />

              <TextField
                fullWidth
                size="small"
                id="primaryPurchaseRequirementCode"
                name="primaryPurchaseRequirementCode"
                type="number"
                label="Primary Purchase Requirement Code"
                placeholder="Default: 0"
                variant="outlined"
                value={data.primaryPurchaseRequirementCode || ""}
                onKeyDown={numericFilter}
                onChange={handleChange}
                error={fieldType === "primaryPurchaseRequirementCode" || primaryPurchaseRequirementCodeReq}
                helperText={(fieldType === "primaryPurchaseRequirementCode" || primaryPurchaseRequirementCodeReq) && "Must be 0, 1, 2, 3, 4, or 9 (GS1 standard)"}
                InputProps={{
                  endAdornment: (
                    <Tooltip
                      title={
                        <Box>
                          <Typography variant="body2" sx={{ fontWeight: 600, mb: 1 }}>
                            Primary Purchase Requirement Code
                          </Typography>
                          <Typography variant="body2" sx={{ mb: 1 }}>
                            Default: 0 — Number of units required
                          </Typography>
                          <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5 }}>
                            All Options:
                          </Typography>
                          <Box component="ul" sx={{ m: 0, pl: 2, '& li': { mb: 0.3 } }}>
                            <li>0 — Number of units required (Most commonly used)</li>
                            <li>1 — Dollar value of qualifying items</li>
                            <li>2 — Dollar value of entire transaction</li>
                            <li>3 — Pounds required</li>
                            <li>4 — Kilograms required</li>
                            <li>9 — Cashier intervention required</li>
                          </Box>
                        </Box>
                      }
                      arrow
                      placement="right"
                    >
                      <InfoIcon fontSize="small" color="action" />
                    </Tooltip>
                  ),
                }}
                sx={{
                  mt: 1,
                  '& .MuiOutlinedInput-root': { borderRadius: '20px' },
                  '& .MuiFormHelperText-root': { fontSize: '0.7rem' }
                }}
              />

              <TextField
                fullWidth
                size="small"
                id="primaryPurchaseFamilyCode"
                name="primaryPurchaseFamilyCode"
                type="number"
                label="Primary Purchase Family Code"
                placeholder="3 digits"
                variant="outlined"
                value={data.primaryPurchaseFamilyCode || ""}
                onKeyDown={numericFilter}
                onChange={handleChange}
                error={fieldType === "primaryPurchaseFamilyCode" || primaryPurchaseFamilyCodeReq}
                helperText={(fieldType === "primaryPurchaseFamilyCode" || primaryPurchaseFamilyCodeReq) && "Please enter exactly 3 digits (use 000 for all products)"}
                InputProps={{
                  endAdornment: (
                    <Tooltip
                      title={
                        <Box>
                          <Typography variant="body2" sx={{ fontWeight: 600, mb: 1 }}>
                            Family Code
                          </Typography>
                          <Typography variant="body2">
                            000 ensures the offer works for all products under the GS1 Company Prefix encoded. You can also assign a specific family code which will require registering into a retailer's POS system through a third party service.
                          </Typography>
                        </Box>
                      }
                      arrow
                      placement="right"
                    >
                      <InfoIcon fontSize="small" color="action" />
                    </Tooltip>
                  ),
                }}
                sx={{
                  mt: 1,
                  '& .MuiOutlinedInput-root': { borderRadius: '20px' },
                  '& .MuiFormHelperText-root': { fontSize: '0.7rem' }
                }}
              />

              <Box sx={{ mt: 2 }}>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5, fontSize: '0.75rem' }}>
                  Barcode string: <code>{`(8110)${data.companyPrefix ? data.companyPrefix.length - 6 : ""}${data.companyPrefix || ""}${data.offerCode || ""}${data.saveValue ? data.saveValue.length : ""}${data.saveValue || ""}${data.primaryPurchaseRequirement ? data.primaryPurchaseRequirement.length : ""}${data.primaryPurchaseRequirement || ""}${data.primaryPurchaseRequirementCode || ""}${data.primaryPurchaseFamilyCode || ""}`}</code>
                </Typography>
              </Box>
            </Box>
          )}

          {activeStep === 1 && (
            <Box>
              <Grid container spacing={1.5} sx={{ mb: 1.5 }}>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    size="small"
                    id="startDate"
                    name="startDate"
                    type="date"
                    label="Start Date"
                    variant="outlined"
                    focused
                    value={startDate || ""}
                    onChange={handleDateChange}
                    InputProps={{
                      endAdornment: (
                        <Tooltip title="Start date">
                          <InfoIcon fontSize="small" color="action" />
                        </Tooltip>
                      ),
                    }}
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: '20px' } }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    size="small"
                    id="expiryDate"
                    name="expiryDate"
                    type="date"
                    label="Expire Date"
                    variant="outlined"
                    focused
                    value={expiryDate || ""}
                    onChange={handleDateChange}
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: '20px' } }}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={1} sx={{ mb: 1.5 }}>
                <Grid item xs={12} md={6}>
                  <FormControlLabel
                    control={<Checkbox size="small" checked={showSerialNumber} onChange={(e) => setShowSerialNumber(!showSerialNumber)} />}
                    label={<Typography fontSize="0.85rem">Have a Serial Number?</Typography>}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormControlLabel
                    control={<Checkbox size="small" checked={freeCoupon} onChange={(e) => setFreeCoupon(!freeCoupon)} />}
                    label={<Typography fontSize="0.85rem">Is this a Free Coupon?</Typography>}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormControlLabel
                    control={<Checkbox size="small" checked={showRetailer} onChange={(e) => setShowRetailer(!showRetailer)} />}
                    label={<Typography fontSize="0.85rem">Have a Retailer ID?</Typography>}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormControlLabel
                    control={<Checkbox size="small" checked={limitedPerOne} onChange={(e) => setLimitedPerOne(!limitedPerOne)} />}
                    label={<Typography fontSize="0.85rem">Limited one per customer?</Typography>}
                  />
                </Grid>
              </Grid>

              {showSerialNumber && (
                <Box sx={{ mb: 1.5 }}>
                  <TextField
                    fullWidth
                    size="small"
                    id="serialNumber"
                    name="serialNumber"
                    type="number"
                    label="Serial Number"
                    placeholder="6-15 digits"
                    variant="outlined"
                    onKeyDown={numericFilter}
                    value={data.serialNumber || ""}
                    onChange={handleChange}
                    error={fieldType === "serialNumber"}
                    helperText={fieldType === "serialNumber" && "Serial Number should be 6-15 digits"}
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: '20px' } }}
                  />
                </Box>
              )}

              {showRetailer && (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1.5 }}>
                  <Autocomplete
                    disablePortal
                    id="retailerCompanyPrefix"
                    options={companyPrefixes}
                    name="retailerCompanyPrefix"
                    value={companyPrefixes.find(cp => cp.value === data.retailerCompanyPrefix) || null}
                    onChange={handleRetailerDropdownChange}
                    autoSelect={true}
                    loading={companyPrefixes.length === 0}
                    sx={{ flex: 1 }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Retailer GS1 Company Prefix"
                        size="small"
                        sx={{
                          '& .MuiOutlinedInput-root': { borderRadius: '20px' }
                        }}
                      />
                    )}
                  />
                  <Tooltip title="Add Retailer Company Prefix">
                    <IconButton
                      className={isAdmin ? "" : "hide"}
                      onClick={() => navigate("/companyprefixes/login")}
                      color="primary"
                      sx={{
                        border: '1px solid #1976d2',
                        borderRadius: '50%',
                        width: 36,
                        height: 36,
                        flexShrink: 0
                      }}
                    >
                      <AddIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </Box>
              )}

              <FormControlLabel
                control={<Checkbox size="small" checked={showSecondPurchase} onChange={handleSecondPurchaseAppearance} />}
                label={<Typography fontSize="0.85rem">Have a Second GS1 Company Prefix?</Typography>}
                sx={{ mb: 1.5 }}
              />

              {showSecondPurchase && (
                <Box sx={{ mb: 1.5 }}>
                  <TextField
                    fullWidth
                    size="small"
                    sx={{ mb: 1.5, '& .MuiOutlinedInput-root': { borderRadius: '20px' }, '& .MuiFormHelperText-root': { fontSize: '0.7rem' } }}
                    id="additionalPurchaseRuleCode"
                    name="additionalPurchaseRuleCode"
                    type="number"
                    label="Additional Purchase Rule Code"
                    placeholder="0-3"
                    variant="outlined"
                    onKeyDown={numericFilter}
                    value={data.additionalPurchaseRuleCode || ""}
                    onChange={handleChange}
                    required={additionalFieldRequired}
                    error={fieldType === "additionalPurchaseRuleCode"}
                    helperText={fieldType === "additionalPurchaseRuleCode" && "Should be 1 digit (0-3)"}
                    InputProps={{
                      endAdornment: (
                        <Tooltip
                          title={
                            <Box>
                              <Typography variant="body2" sx={{ fontWeight: 600, mb: 1 }}>
                                Additional Purchase Rule Code
                              </Typography>
                              <Box component="ul" sx={{ m: 0, pl: 2, '& li': { mb: 0.5 } }}>
                                <li><strong>0:</strong> Only one item from one Company Prefix is needed to qualify.</li>
                                <li><strong>1:</strong> All items under both Company Prefixes must be purchased to qualify.</li>
                                <li><strong>2:</strong> The Primary Item plus either the 2nd or 3rd Item must be purchased.</li>
                                <li><strong>3:</strong> Items from the 2nd or 3rd Company Prefix / Family Code combinations can substitute for the Primary Item.</li>
                              </Box>
                            </Box>
                          }
                          arrow
                          placement="right"
                        >
                          <InfoIcon fontSize="small" color="action" />
                        </Tooltip>
                      ),
                    }}
                  />
                  <TextField
                    fullWidth
                    size="small"
                    sx={{ mb: 1.5, '& .MuiOutlinedInput-root': { borderRadius: '20px' } }}
                    id="secondPurchaseRequirement"
                    name="secondPurchaseRequirement"
                    type="number"
                    label="Second Purchase Requirement"
                    placeholder="1-5 digits"
                    variant="outlined"
                    onKeyDown={numericFilter}
                    value={data.secondPurchaseRequirement || ""}
                    onChange={handleChange}
                    required={additionalFieldRequired}
                    error={fieldType === "secondPurchaseRequirement"}
                    helperText={fieldType === "secondPurchaseRequirement" && "Should be 1-5 digits"}
                  />
                  <TextField
                    fullWidth
                    size="small"
                    sx={{ mb: 1.5, '& .MuiOutlinedInput-root': { borderRadius: '20px' } }}
                    id="secondPurchaseRequirementCode"
                    name="secondPurchaseRequirementCode"
                    type="number"
                    label="Second Purchase Requirement Code"
                    placeholder="0-4 or 9"
                    variant="outlined"
                    onKeyDown={numericFilter}
                    value={data.secondPurchaseRequirementCode || ""}
                    onChange={handleChange}
                    required={additionalFieldRequired}
                    error={fieldType === "secondPurchaseRequirementCode"}
                    helperText={fieldType === "secondPurchaseRequirementCode" && "Must be 0, 1, 2, 3, 4, or 9 (GS1 standard)"}
                  />
                  <TextField
                    fullWidth
                    size="small"
                    sx={{ mb: 1.5, '& .MuiOutlinedInput-root': { borderRadius: '20px' } }}
                    id="secondPurchaseFamilyCode"
                    name="secondPurchaseFamilyCode"
                    type="number"
                    label="Second Purchase Family Code"
                    placeholder="3 digits"
                    variant="outlined"
                    onKeyDown={numericFilter}
                    value={data.secondPurchaseFamilyCode || ""}
                    onChange={handleChange}
                    required={additionalFieldRequired}
                    error={fieldType === "secondPurchaseFamilyCode"}
                    helperText={fieldType === "secondPurchaseFamilyCode" && "Should be 3 digits"}
                  />
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <Autocomplete
                      disablePortal
                      id="secondCompanyPrefix"
                      options={companyPrefixes}
                      name="secondCompanyPrefix"
                      onChange={handleSecondDropdownChange}
                      autoSelect={true}
                      loading={companyPrefixes.length === 0}
                      value={secondPurchaseCompany || null}
                      sx={{ flex: 1 }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Second Purchase GS1 Company Prefix"
                          size="small"
                          required={additionalFieldRequired}
                          sx={{
                            '& .MuiOutlinedInput-root': { borderRadius: '20px' }
                          }}
                        />
                      )}
                    />
                    <Tooltip title="Add Second Company Prefix">
                      <IconButton
                        className={isAdmin ? "" : "hide"}
                        onClick={() => navigate("/companyprefixes/login")}
                        color="primary"
                        sx={{
                          border: '1px solid #1976d2',
                          borderRadius: '50%',
                          width: 36,
                          height: 36,
                          flexShrink: 0
                        }}
                      >
                        <AddIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </Box>
                </Box>
              )}

              <Grid container spacing={1.5}>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    size="small"
                    id="saveValueCode"
                    name="saveValueCode"
                    type="number"
                    label="Save Value Code"
                    placeholder="Default: 0"
                    variant="outlined"
                    onKeyDown={numericFilter}
                    value={data.saveValueCode || ""}
                    onChange={handleChange}
                    required={valueCodeFlagAppliesRequired}
                    error={fieldType === "saveValueCode"}
                    helperText={fieldType === "saveValueCode" && "Must be 0, 1, or 2"}
                    InputProps={{
                      endAdornment: (
                        <Tooltip
                          title={
                            <Box>
                              <Typography variant="body2" sx={{ fontWeight: 600, mb: 1 }}>
                                Save Value Code
                              </Typography>
                              <Box component="ul" sx={{ m: 0, pl: 2, '& li': { mb: 0.3 } }}>
                                <li><strong>0</strong> = Cents Off Item (Save $1.00 off one)</li>
                                <li><strong>1</strong> = One Free Item (Get One Free up to x)</li>
                                <li><strong>2</strong> = Multiple Free Items (Buy 5, Get 2 Free)</li>
                              </Box>
                              <Typography variant="body2" sx={{ mt: 1, fontStyle: 'italic' }}>
                                *Default is 0.
                              </Typography>
                            </Box>
                          }
                          arrow
                          placement="right"
                        >
                          <InfoIcon fontSize="small" color="action" />
                        </Tooltip>
                      ),
                    }}
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: '20px' }, '& .MuiFormHelperText-root': { fontSize: '0.7rem' } }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    size="small"
                    id="saveValueAppliesItem"
                    name="saveValueAppliesItem"
                    type="number"
                    label="Save Value Applies To"
                    placeholder="Default: 0"
                    variant="outlined"
                    onKeyDown={numericFilter}
                    value={data.saveValueAppliesItem || ""}
                    onChange={handleChange}
                    required={valueCodeFlagAppliesRequired}
                    error={fieldType === "saveValueAppliesItem"}
                    helperText={fieldType === "saveValueAppliesItem" && "Must be 0, 1, or 2"}
                    InputProps={{
                      endAdornment: (
                        <Tooltip
                          title={
                            <Box>
                              <Typography variant="body2" sx={{ fontWeight: 600, mb: 1 }}>
                                Save Value Applies To
                              </Typography>
                              <Box component="ul" sx={{ m: 0, pl: 2, '& li': { mb: 0.3 } }}>
                                <li><strong>0</strong> = the Primary Item</li>
                                <li><strong>1</strong> = The Second Qualifying Item</li>
                                <li><strong>2</strong> = The Third Qualifying Item</li>
                              </Box>
                              <Typography variant="body2" sx={{ mt: 1, fontStyle: 'italic' }}>
                                *Default is 0.
                              </Typography>
                            </Box>
                          }
                          arrow
                          placement="right"
                        >
                          <InfoIcon fontSize="small" color="action" />
                        </Tooltip>
                      ),
                    }}
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: '20px' }, '& .MuiFormHelperText-root': { fontSize: '0.7rem' } }}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={1.5} sx={{ mt: 0.5 }}>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    size="small"
                    id="storeCoupon"
                    name="storeCoupon"
                    type="number"
                    label="Store Coupon Flag"
                    placeholder="Default: 0"
                    variant="outlined"
                    onKeyDown={numericFilter}
                    value={data.storeCoupon || ""}
                    onChange={handleChange}
                    required={valueCodeFlagAppliesRequired}
                    error={fieldType === "storeCoupon"}
                    helperText={fieldType === "storeCoupon" && "Must be 0, 1, or 2"}
                    InputProps={{
                      endAdornment: (
                        <Tooltip
                          title={
                            <Box>
                              <Typography variant="body2" sx={{ fontWeight: 600, mb: 1 }}>
                                Store Coupon Flag
                              </Typography>
                              <Box component="ul" sx={{ m: 0, pl: 2, '& li': { mb: 0.3 } }}>
                                <li><strong>0</strong> = Manufacturer Coupon, Not a Retailer Created Coupon</li>
                                <li><strong>1</strong> = Applies to One Qualifying Item</li>
                                <li><strong>2</strong> = Applies to Two Qualifying Items</li>
                              </Box>
                              <Typography variant="body2" sx={{ mt: 1, fontStyle: 'italic' }}>
                                *Default is 0.
                              </Typography>
                            </Box>
                          }
                          arrow
                          placement="right"
                        >
                          <InfoIcon fontSize="small" color="action" />
                        </Tooltip>
                      ),
                    }}
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: '20px' }, '& .MuiFormHelperText-root': { fontSize: '0.7rem' } }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    size="small"
                    id="multiplyFlag"
                    name="multiplyFlag"
                    type="number"
                    label="Don't Multiply Flag"
                    placeholder="Default: 0"
                    variant="outlined"
                    onKeyDown={numericFilter}
                    value={data.multiplyFlag || ""}
                    onChange={handleChange}
                    required={valueCodeFlagAppliesRequired}
                    error={fieldType === "multiplyFlag"}
                    helperText={fieldType === "multiplyFlag" && "Must be 0 or 1"}
                    InputProps={{
                      endAdornment: (
                        <Tooltip
                          title={
                            <Box>
                              <Typography variant="body2" sx={{ fontWeight: 600, mb: 1 }}>
                                Don't Multiply Flag
                              </Typography>
                              <Box component="ul" sx={{ m: 0, pl: 2, '& li': { mb: 0.3 } }}>
                                <li><strong>0</strong> = Ok to Multiply</li>
                                <li><strong>1</strong> = Do Not Multiply (Limited to One Coupon)</li>
                              </Box>
                              <Typography variant="body2" sx={{ mt: 1, fontStyle: 'italic' }}>
                                *Default is 0.
                              </Typography>
                            </Box>
                          }
                          arrow
                          placement="right"
                        >
                          <InfoIcon fontSize="small" color="action" />
                        </Tooltip>
                      ),
                    }}
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: '20px' }, '& .MuiFormHelperText-root': { fontSize: '0.7rem' } }}
                  />
                </Grid>
              </Grid>

              <Box sx={{ mt: 2 }}>
                <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.75rem' }}>
                  Barcode string: <code>{`(8110)${data.companyPrefix ? data.companyPrefix.length - 6 : ""}${data.companyPrefix || ""}${data.offerCode || ""}${data.saveValue ? data.saveValue.length : ""}${data.saveValue || ""}${data.primaryPurchaseRequirement ? data.primaryPurchaseRequirement.length : ""}${data.primaryPurchaseRequirement || ""}${data.primaryPurchaseRequirementCode || ""}${data.primaryPurchaseFamilyCode || ""}${data.startDate ? `4${data.startDate}` : ''}${data.expiryDate ? `3${data.expiryDate}` : ''}`}</code>
                </Typography>
              </Box>
            </Box>
          )}

          {activeStep === 2 && (
            <Box>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <Box sx={{ bgcolor: '#f5f5f5', p: 2, borderRadius: 2, textAlign: 'center', minHeight: 180 }}>
                    {src ? (
                      <img src={src} alt="barcode" style={{ maxWidth: '100%', height: 'auto' }} />
                    ) : (
                      <Skeleton variant="rectangular" width="100%" height={150} />
                    )}
                  </Box>
                  <Typography variant="body2" color="text.secondary" sx={{ mt: 1, fontSize: '0.7rem' }}>
                    {dataString}
                  </Typography>
                </Grid>

                <Grid item xs={12} md={6}>
                  <FormControl size="small" sx={{ mb: 1.5, width: '50%' }}>
                    <InputLabel>File Type</InputLabel>
                    <Select
                      value={fileType}
                      label="File Type"
                      onChange={handleFileTypeChange}
                      sx={{ borderRadius: '20px' }}
                    >
                      <MenuItem value="png">PNG</MenuItem>
                      <MenuItem value="pdf">PDF</MenuItem>
                      <MenuItem value="eps">EPS</MenuItem>
                    </Select>
                  </FormControl>

                  <FormControl size="small" sx={{ mb: 1.5, width: '100%' }}>
                    <InputLabel>Download Quality</InputLabel>
                    <Select
                      value={downloadQuality}
                      label="Download Quality"
                      onChange={handleQualityChange}
                      sx={{ borderRadius: '20px' }}
                    >
                      <MenuItem value="standard">Standard (3x) - Web Use</MenuItem>
                      <MenuItem value="high">High (6x) - Professional</MenuItem>
                      <MenuItem value="print">Print Quality (10x) - Commercial</MenuItem>
                    </Select>
                  </FormControl>

                  <Button
                    fullWidth
                    size="small"
                    variant="outlined"
                    startIcon={<SaveAltIcon />}
                    onClick={handleDownload}
                    disabled={!src}
                    sx={{
                      mb: 1.5,
                      borderRadius: '20px',
                      height: 38
                    }}
                  >
                    Download
                  </Button>

                  <Box component="form" onSubmit={handleSendMail}>
                    <TextField
                      fullWidth
                      size="small"
                      id="email"
                      name="email"
                      type="email"
                      label="Email Barcode"
                      placeholder="Enter email"
                      variant="outlined"
                      required
                      value={email}
                      onChange={onEmailChange}
                      sx={{
                        mb: 1.5,
                        '& .MuiOutlinedInput-root': { borderRadius: '20px' }
                      }}
                    />
                    <Button
                      fullWidth
                      size="small"
                      type="submit"
                      variant="outlined"
                      startIcon={<MailIcon />}
                      disabled={!src}
                      sx={{
                        borderRadius: '20px',
                        height: 38
                      }}
                    >
                      Send email
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          )}

          {activeStep === 3 && (
            <Box>
              {/* Product & Offer Details Section */}
              <Typography variant="h6" sx={{ mb: 2, fontSize: '1.1rem', fontWeight: 600 }}>
                Product & Offer Details
              </Typography>

              <Grid container spacing={3} sx={{ mb: 3 }}>
                {/* Left Column - Image Upload */}
                <Grid item xs={12} md={4}>
                  <Box sx={{
                    bgcolor: '#f5f5f5',
                    borderRadius: 3,
                    p: 3,
                    textAlign: 'center',
                    minHeight: 200,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100%'
                  }}>
                    {productImage.length > 0 ? (
                      <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                        {productImage.map((item, key) => (
                          <img
                            key={key}
                            src={item}
                            alt="product-image"
                            loading="lazy"
                            style={{ maxWidth: '150px', maxHeight: '150px', objectFit: 'contain' }}
                          />
                        ))}
                      </Box>
                    ) : (
                      <Box sx={{
                        width: 80,
                        height: 80,
                        bgcolor: '#e0e0e0',
                        borderRadius: 2,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        mb: 2
                      }}>
                        <AddPhotoAlternateIcon sx={{ fontSize: 40, color: '#9e9e9e' }} />
                      </Box>
                    )}
                    <Button
                      component="label"
                      variant="text"
                      sx={{ textTransform: 'none', color: '#1976d2', fontSize: '0.9rem', fontWeight: 500 }}
                    >
                      Browse Image
                      <input
                        type="file"
                        hidden
                        multiple
                        accept="image/*"
                        onChange={(e) => {
                          const files = Array.from(e.target.files);
                          files.forEach(file => convertToBase64(file));
                        }}
                      />
                    </Button>
                  </Box>
                </Grid>

                {/* Right Column - Input Fields */}
                <Grid item xs={12} md={8}>
                  {/* Product Name and Category in same row */}
                  <Grid container spacing={2} sx={{ mb: 2 }}>
                    <Grid item xs={12} md={6}>
                      <TextField
                        name="name"
                        type="text"
                        label="Product Name"
                        variant="outlined"
                        fullWidth
                        size="small"
                        value={productData.name || ""}
                        onChange={handleProductChange}
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '25px',
                            height: '40px'
                          },
                          '& .MuiFormHelperText-root': { fontSize: '0.7rem' }
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Autocomplete
                        disablePortal
                        options={productCategories}
                        name="category"
                        onChange={handleCategoryChange}
                        autoSelect={true}
                        loading={productCategories.length === 0}
                        fullWidth
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Product Category"
                            size="small"
                            sx={{
                              '& .MuiOutlinedInput-root': {
                                borderRadius: '25px',
                                height: '40px'
                              },
                              '& .MuiFormHelperText-root': { fontSize: '0.7rem' }
                            }}
                          />
                        )}
                      />
                    </Grid>
                  </Grid>

                  {/* Offer Details */}
                  <TextField
                    name="offerDesc"
                    type="text"
                    label="Offer Details"
                    variant="outlined"
                    fullWidth
                    size="small"
                    value={productData.offerDesc || ""}
                    onChange={handleProductChange}
                    sx={{
                      mb: 2,
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '25px',
                        height: '40px'
                      },
                      '& .MuiFormHelperText-root': { fontSize: '0.7rem' }
                    }}
                  />

                  {/* Short Description */}
                  <TextField
                    name="shortDesc"
                    type="text"
                    label="Short Description"
                    variant="outlined"
                    fullWidth
                    size="small"
                    value={productData.shortDesc || ""}
                    onChange={handleProductChange}
                    sx={{
                      mb: 2,
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '25px',
                        height: '40px'
                      },
                      '& .MuiFormHelperText-root': { fontSize: '0.7rem' }
                    }}
                  />

                  {/* To The Retailer */}
                  <TextField
                    name="retailer"
                    type="text"
                    label="To The Retailer"
                    variant="outlined"
                    fullWidth
                    size="small"
                    value={productData.retailer || ""}
                    onChange={handleProductChange}
                    sx={{
                      mb: 2,
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '25px',
                        height: '40px'
                      },
                      '& .MuiFormHelperText-root': { fontSize: '0.7rem' }
                    }}
                  />

                  {/* To The Consumer */}
                  <TextField
                    name="consumer"
                    type="text"
                    label="To The Consumer"
                    variant="outlined"
                    fullWidth
                    size="small"
                    value={productData.consumer || ""}
                    onChange={handleProductChange}
                    sx={{
                      mb: 0,
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '25px',
                        height: '40px'
                      },
                      '& .MuiFormHelperText-root': { fontSize: '0.7rem' }
                    }}
                  />
                </Grid>
              </Grid>

              {/* Preview Coupon Section */}
              <Typography variant="h6" sx={{ mb: 2, fontSize: '1.1rem', fontWeight: 600 }}>
                Preview Coupon
              </Typography>

              <Grid container spacing={3}>
                {/* Left Column - Coupon Preview */}
                <Grid item xs={12} md={8}>
                  <Box sx={{
                    bgcolor: '#e8e8e8',
                    borderRadius: 2,
                    p: 2,
                    minHeight: 260,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    {src ? (
                      <Box
                        id="coupon-preview"
                        sx={{
                          bgcolor: 'white',
                          borderRadius: 2,
                          width: '100%',
                          overflow: 'hidden'
                        }}>
                        {/* Blue Header Bar - Full Width */}
                        <Box sx={{ bgcolor: '#1565c0', px: 1.5, py: 0.75 }}>
                          <Typography variant="caption" sx={{ fontSize: '0.6rem', color: 'white', display: 'block', textAlign: 'center', fontWeight: 500 }}>
                            Limit one Coupon per visit | Manufacturer's Coupon
                          </Typography>
                        </Box>

                        {/* Content Area */}
                        <Box sx={{ display: 'flex', gap: 2, p: 2 }}>
                          {/* Left Side - Product Image (30%) */}
                          {productImage.length > 0 && (
                            <Box sx={{ width: '30%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                              <img
                                src={productImage[0]}
                                alt="product"
                                style={{ width: '100%', height: 'auto', objectFit: 'contain', maxHeight: '200px', border: '1px solid black', padding: '8px', borderRadius: '8px' }}
                              />
                            </Box>
                          )}

                          {/* Right Side - Content (70%) */}
                          <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                            <Typography variant="h6" sx={{ fontSize: '0.95rem', fontWeight: 'bold', color: '#1565c0', mb: 0.5 }}>
                              {productData.offerDesc || 'Save $1.00 Now'}
                            </Typography>
                            <Typography variant="body2" sx={{ fontSize: '0.75rem', fontWeight: 500, mb: 0.5 }}>
                              {productData.name || 'Product Name - 1Kg'}
                            </Typography>
                            <Typography variant="caption" sx={{ fontSize: '0.65rem', color: '#666', lineHeight: 1.3, mb: 1 }}>
                              {productData.shortDesc || 'Product description goes here'}
                            </Typography>

                            <Box sx={{ my: 1 }}>
                              <img src={src} alt="code" style={{ maxWidth: '100%', height: 'auto', maxHeight: '80px' }} />
                            </Box>

                            <Typography variant="caption" sx={{ fontSize: '0.55rem', color: '#333', display: 'block', mb: 0.5, lineHeight: 1.3 }}>
                              <strong>TO THE CONSUMER:</strong> {productData.consumer || 'Do not double. Valid one per household...'}
                            </Typography>
                            <Typography variant="caption" sx={{ fontSize: '0.55rem', color: '#333', display: 'block', lineHeight: 1.3 }}>
                              <strong>TO THE RETAILER:</strong> {productData.retailer || 'Do not double. Void when reproduced, copied, transferred, etc.'}
                            </Typography>
                          </Box>
                        </Box>
                      </Box>
                    ) : (
                      <Typography variant="body2" color="text.secondary">
                        Coupon preview will appear here
                      </Typography>
                    )}
                  </Box>
                </Grid>

                {/* Right Column - Action Buttons */}
                <Grid item xs={12} md={4}>
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, justifyContent: 'center', height: '100%' }}>
                    <Button
                      fullWidth
                      variant="outlined"
                      startIcon={<DownloadIcon />}
                      disabled={!src}
                      sx={{ borderRadius: '25px', textTransform: 'none', py: 1 }}
                      onClick={handleDownloadCoupon}
                    >
                      Download
                    </Button>

                    {/* Email Input and Send Button */}
                    <Box component="form" onSubmit={handleSendCouponEmail}>
                      <TextField
                        fullWidth
                        size="small"
                        type="email"
                        label="Email Address"
                        placeholder="Enter email"
                        variant="outlined"
                        required
                        value={couponEmail}
                        onChange={(e) => setCouponEmail(e.target.value)}
                        sx={{
                          mb: 1.5,
                          '& .MuiOutlinedInput-root': { borderRadius: '25px' }
                        }}
                      />
                      <Button
                        fullWidth
                        type="submit"
                        variant="outlined"
                        startIcon={<SendIcon />}
                        disabled={!src}
                        sx={{ borderRadius: '25px', textTransform: 'none', py: 1 }}
                      >
                        Send
                      </Button>
                    </Box>

                    <Button
                      fullWidth
                      variant="outlined"
                      color="error"
                      startIcon={<DeleteIcon />}
                      disabled={!src}
                      sx={{ borderRadius: '25px', textTransform: 'none', py: 1 }}
                      onClick={() => {
                        setProductImage([]);
                        setProductData({});
                      }}
                    >
                      Delete
                    </Button>

                    {/* Footer Links */}
                    <Box sx={{ mt: 2, textAlign: 'center' }}>
                      <Link href="#" underline="hover" sx={{ fontSize: '0.75rem', color: '#1976d2', mr: 2 }}>
                        Privacy Policy
                      </Link>
                      <Link href="#" underline="hover" sx={{ fontSize: '0.75rem', color: '#1976d2' }}>
                        Terms of Use
                      </Link>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          )}

          {/* Navigation Buttons */}
          <Box sx={{ mt: 3, mb: 2 }}>
            {activeStep < steps.length - 1 ? (
              <Button
                fullWidth
                size="small"
                variant="contained"
                onClick={handleNext}
                endIcon={<ChevronRightIcon />}
                disabled={activeStep === 2 && !src}
                sx={{
                  borderRadius: '20px',
                  px: 3,
                  py: 0.75
                }}
              >
                Next Step
              </Button>
            ) : (
              <Button
                fullWidth
                size="small"
                variant="contained"
                startIcon={<ConfirmationNumberIcon />}
                disabled={!src}
                onClick={handleSaveCoupon}
                sx={{
                  borderRadius: '20px',
                  px: 3,
                  py: 0.75
                }}
              >
                Save Coupon
              </Button>
            )}
          </Box>
        </Paper>
        </Box>
      </Box>

      <SubscriptionModal
        show={showSubscriptionModal}
        onHide={handleHideSubscriptionModal}
      />
    </MainWrapper>
  );
}

export default BarcodeWizard;
